import { ForecastFiltersContext } from '../../../../state/filters/contexts';
import moment from 'moment';
import { boolPropsToClassNames } from 'common/utils/style.utils';
import { StyledRemainingDays } from './RemainingDays.style';
import useSelectedFilterSet from '../../../../state/filters/hooks/useSelectedFilterSet';

const RemainingDays = () => {
  const selectedFilterSet = useSelectedFilterSet(ForecastFiltersContext);
  const dueDate = selectedFilterSet?.metadata?.due_date;
  const remainingDays = moment(dueDate)
    .startOf('day')
    .diff(moment().startOf('day'), 'days');
  const isOverdue = remainingDays < 0;
  const remainingDaysInView = dueDate ? Math.abs(remainingDays) : '?';

  const description = isOverdue ? (
    <>
      days passed since <br />
      the target date.
    </>
  ) : (
    <>
      days remaining until <br />
      the project target date.
    </>
  );

  return (
    <StyledRemainingDays className={boolPropsToClassNames({ isOverdue })}>
      <div className='value'>{remainingDaysInView}</div>
      <div className='description'>{description}</div>
    </StyledRemainingDays>
  );
};

export default RemainingDays;
